import {PureComponent, ReactNode} from 'react';

type PropsType = {
    children: ReactNode;
};

type StateType = {
    hasError: boolean;
};

/**
 * Class for SafeRender component - catch children components errors
 */
export class SafeRender extends PureComponent<PropsType, StateType> {
    state = {
        hasError: false,
    };

    /**
     * Method works like a JavaScript catch {} block, but for components.
     * @param {object} error - error text
     * @param {object} info - info about error
     */
    componentDidCatch(error: {}, info: {}) {
        this.setState({hasError: true});
        const {children} = this.props;
        // @ts-expect-error
        const compName = children && children.type && children.type.displayName;
        console.log(`Component: ${compName}\n`, error, info); // eslint-disable-line no-console
    }

    /**
     * Render jsx to html
     *
     * @returns {Node} Rendered react component
     */
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
}
